<app-alerts></app-alerts>

<div>

   <!--  <div class="row">
<div class="col-12">
		<h5 class="mainTitle">Трансляции</h5>
</div>

</div> -->
 
  <div   class="row mob-mt-10">

    <div class="col-4 col-sm-6 col-md col-ls col-xl "> 

	<div class="controlsPanelItems">
        <div  class="topPanel">

        <!--          {{'account.pages.streams.hello' | translate}}
-->
	    <button  *ngIf="!fetchLoading"  (click)="createMenuOpened = !createMenuOpened"  nbButton status="primary" > {{'account.pages.streams.createButton.w1' | translate}}  
	      <span  style="margin-left:3px"  class="d-none d-md-inline d-lg-inline d-xl-inline"> {{'account.pages.streams.createButton.w2' | translate}}</span> <i style="   margin-left: 10px;" class="fa fa-chevron-down"></i></button>
		<ngx-skeleton-loader  *ngIf="fetchLoading"   [theme]="{  width: '200px',   height: '40px'  }"></ngx-skeleton-loader>
	
	
	 
			  <div *ngIf="createMenuOpened" class="createStreamMenu themeBg">
			  
			  
			      <div (click)="createMenuOpened = false; createStream(1)"  class="createStreamMenuItem">
			      	   <h5>Стандартна трансляція</h5>
			      	     <p>Макс. тривалість 12 години. Є запис.</p>
			      </div>
			  
			      <div (click)="createMenuOpened = false; createStream(2)"  class="createStreamMenuItem">
			      	   <h5>Нескінченна трансляція</h5>
			      	     <p>Нескінченна тривалість. Немає запису.</p>
			      </div>
			  
			 
			  </div>
	  
	        
	
	  </div>
	
 </div>

    </div>

    <div class="col d-none   d-md-block d-lg-block d-xl-block"></div>
    <div class="col d-none   d-md-block d-lg-block d-xl-block"></div>

    <div class="col-8   col-sm-6 col-md col-ls col-xl ">
	<app-grid-density-control *ngIf="!fetchLoading"
		[storageKey]="colsKey"
		(changed)="cols = $event"></app-grid-density-control>
	<!--<div class="controlsPanelItems"><div class="right">
      <nb-toggle  labelPosition="left" [(checked)]="showControls" status="primary">Редактировать</nb-toggle>
</div></div> -->
    </div>

  </div>

<!-- fetchLoading -->
  <div class="pagesWrapper"> 
      <div *ngIf="!fetchLoading; else skeleton">
 <div class="cardGrid" [ngClass]="'cols-' + cols">
  
        <div *ngFor="let stream of streams" class="col-item">
          <div 
          class="overviewStreamCard" > 

          <div [routerLink]="['/stream',stream._id]"    class="itemPreview" >

          <div class="cover"
          [style.background]="'url(' +(stream.isRunning ? '/uploads/thumbs/'+stream._id+'/'+stream.streamKey+'.jpg?'+timeNow : (stream.thumbImage ? '/'+stream.thumbImage : ''))+')'"
          ></div>
          </div>
		 
		
              <div class="top-nav" >
                
                <!--  
                <button nbButton *ngIf="!stream.isRunning && showControls" (click)="openRemoveModal(deleteModal, stream, $event)" status="danger">Удалить</button> -->
               
              </div>
 
 
 


<div class="streamType" *ngIf="stream.streamType === 2"  [routerLink]="['/stream',stream._id]" >
<span title="Трансляція без запису" class="ico hdd"></span>
</div>

<div class="streamShowTime"  [routerLink]="['/stream',stream._id]" >
  <span  *ngIf="stream.show_date" class="showTime">  
  <span>{{stream.show_date | date : 'dd.MM.yy'}}</span>
    <span>{{stream.show_date | date : 'HH:mm'}}</span>

  </span>

  <span class="ico opened"  [ngClass]="{opened: !stream.accessLevel, closed: stream.accessLevel}"> 

    <!-- 
	<nb-icon *ngIf="!stream.accessLevel" [icon]="'globe-outline'" pack="eva" status="primary"></nb-icon>

	<nb-icon *ngIf="stream.accessLevel" [icon]="'lock-outline'" pack="eva" status="primary"></nb-icon>
  -->

  </span> 
</div>
              



        <div class="live-label5" *ngIf="!stream.isRunning && stream.hasSignal">
          <div class="lbl signal">
          <span>SIGNAL</span>
         
          </div>  
 
        </div>


        <div class="live-label5" *ngIf="stream.isRunning">
                <div class="lbl live">
                <span>LIVE</span>
                </div>
                <div class="count-watchers">
                  <span>{{stream.watchersCount }}</span>
                  </div>
              </div>


        <div class="live-label5" *ngIf="stream.watchersCount && !stream.isRunning && !stream.hasSignal">
          <div class="lbl watch">
          <span></span>
          </div>
          <div class="count-watchers">
            <span>{{stream.watchersCount }}</span>
            </div>
        </div>






              <div class="title"><div class="title-text"  [routerLink]="['/stream',stream._id]" >{{stream.title}}</div>

			<div *ngIf="!stream.isRunning && !stream.hasSignal"  nbContextMenuTag="stream-menu"   [nbContextMenu]="[{ title: 'Видалити', item:stream, cmd:'remove'}]"  class="title-menu">

<nb-icon  [icon]="'more-vertical-outline'" pack="eva"></nb-icon>
			</div>

		</div>
              </div>
        </div>




       

      </div>
    </div>


	 <div *ngIf="removeLoading" style="position: fixed; z-index: 777; background-color:rgba(0,0,0,0.5); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>

      <ng-template #loader>
        <div style="position: fixed; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>
    </ng-template> 

   <ng-template #skeleton>
	 
	<app-skeleton-overviews [length]="16" [cols]="cols" [ratio]="'16 / 9'" ></app-skeleton-overviews> 
  
    </ng-template> 





 
 <ng-template #deleteModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Видалити трансляцію?</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
      <p>Увага! Ця дія видалить трансляцію і всі пов'язані дані, ви впевнені, що хочете продовжити?</p>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="removeSelectedStream(ref)" nbButton status="danger" >Видалити трансляцію</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>
    
     
   


  </div>
 
</div> 

<!---->

